import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./CardBody.module.scss";

export default function CardBody(props) {
  const {
    className,
    children,
    background,
    plain,
    formHorizontal,
    pricing,
    signup,
    color,
    ...rest
  } = props;
  const cardBodyClasses = classNames(
    styles.cardBody,
    {
      [styles.cardBodyBackground]: background,
      [styles.cardBodyPlain]: plain,
      [styles.cardBodyFormHorizontal]: formHorizontal,
      [styles.cardPricing]: pricing,
      [styles.cardSignup]: signup,
      [styles.cardBodyColor]: color
    },
    className
  );
  return (
    <div className={cardBodyClasses} {...rest}>
      {children}
    </div>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  background: PropTypes.bool,
  plain: PropTypes.bool,
  formHorizontal: PropTypes.bool,
  pricing: PropTypes.bool,
  signup: PropTypes.bool,
  color: PropTypes.bool,
  children: PropTypes.node
};
